import type { MindItemSearchResult, SearchResponseData } from '@kimuno/api-sdk';

import type { AsyncAction } from './common.actionTypes';

export enum FETCH_DASHBOARD_WORKSHEETS {
	START = 'FETCH_DASHBOARD_WORKSHEETS_START',
	SUCCESS = 'FETCH_DASHBOARD_WORKSHEETS_SUCCESS',
	ERROR = 'FETCH_DASHBOARD_WORKSHEETS_ERROR',
}

export interface DashboardWorksheetsRequest {
	subjects: string[];
	classYears: number[];
}

export interface DashboardWorksheetsResult extends SearchResponseData<MindItemSearchResult> {
	// The class years the shown results were filtered by — `[]` when the request had
	// none, or when the grade-filtered search came back short and fell back.
	appliedClassYears: number[];
}

export const getDashboardWorksheetsKey = ({ subjects, classYears }: DashboardWorksheetsRequest) =>
	`${subjects.join(',')}|${classYears.join(',')}`;

export type FetchDashboardWorksheetsAction = AsyncAction<
	typeof FETCH_DASHBOARD_WORKSHEETS.START,
	typeof FETCH_DASHBOARD_WORKSHEETS.SUCCESS,
	typeof FETCH_DASHBOARD_WORKSHEETS.ERROR,
	DashboardWorksheetsResult,
	DashboardWorksheetsRequest
>;
